<template>
  <transition name="c-modalZoom">
  <div v-if="isShow" class="c-modalZoom isOpen">
    <div class="c-modalZoom__wrap" :style="setStyleWrap()">
      <img :src="`${assets_path}images/product/feature/${imgSrc}`" alt="" />
    </div>

    <div class="c-modalZoom__btn">
      <div class="c-modalZoom__close" @click="close">
        <div class="c-modalZoom__closeWrap">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables';

  export default {
    data() {
      return {
        assets_path: assets_path,
        lang: '',
        ispc: false,
        adjust: {
          pc: {
            h: 170,
            w: 240
          },
          sp: {
            h: 80,
            w: 20
          }
        },
        isShow: false,
        preWidth: 0,
        styleWrap: '',
        imgSrc: ''
      }
    },
    computed: {
      setStyleWrap: function() {
        return function() {
          return this.styleWrap;
        }
      }
    },
    created() {

    },
    mounted() {
      this.lang = this.$store.getters.getLang;

      if (this.lang === 'ja') {
        this.imgSrc = 'graf-ja.jpg';
      } else if (this.lang === 'en') {
        this.imgSrc = 'graf-en.jpg';
      } else if (this.lang === 'de') {
        this.imgSrc = 'graf-en.jpg';
      } else if (this.lang === 'fr') {
        this.imgSrc = 'graf-en.jpg';
      } else if (this.lang === 'it') {
        this.imgSrc = 'graf-en.jpg';
      } else if (this.lang === 'es') {
        this.imgSrc = 'graf-en.jpg';
      } else if (this.lang === 'zh-cmn-Hans') {
        this.imgSrc = 'graf-sc.jpg';
      } else if (this.lang === 'zh-cmn-Hant') {
        this.imgSrc = 'graf-tc.jpg';
      } else {
        this.imgSrc = 'graf-ja.jpg';
      }

      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
      resize() {
        if (!this.isShow) return;

        let imgW = 620, imgH = 560;
        const winW = this.getBodyWidth();
        const winH = window.innerHeight;
        this.windowHeight = winH;

        let adjust = {};
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
          adjust = this.adjust.pc;
        } else {
          this.ispc = false;
          adjust = this.adjust.sp;
        }

        if (this.ispc || this.preWidth !== winW) {
          // ブラウザサイズにフィット
          const bgW = winW - adjust.w;
          const bgH = winH - adjust.h;
          const scale = Math.min(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (bgW - frameW) / 2;
          const frameY = (bgH - frameH) / 2;

          this.styleWrap = `height:${frameH}px; width:${frameW}px`;
        }
      },
      open() {
        this.isShow = true;
        this.resize();
      },
      close() {
        this.isShow = false;
      },
      getBodyWidth() {
        return document.body.clientWidth || window.innerWidth;
      }
    }
  }
</script>